module.exports = __webpack_public_path__ + "static/media/eye.85e2e0c2.svg";